/**
 * Converte a linha de Relatórios (chamados técnicos) em "order" do report OS v2,
 * com o bloco de fechamento (`reportClosure`) preenchido.
 */
import { getApiBaseUrl } from '../../../utils/apiConfig';

const empresaCache = new Map();

const TIPO_CODE = {
  ESTOQUE: 'E',
  BALCAO: 'B',
  AFERICAO: 'A',
  'RETORNO/RECARGA': 'R',
  DESINSTALACAO: 'D',
  INSTALACAO: 'I',
  PREVENTIVA: 'S',
  CORRETIVA: 'N',
};

function clean(value) {
  const s = value == null ? '' : String(value).trim();
  return s === '-' || s === '—' ? '' : s;
}

function signatureSrc(svg) {
  const s = clean(svg);
  if (!s) return '';
  if (s.startsWith('data:image/svg')) return s;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(s)}`;
}

async function fetchEmpresaHeader(codEmpresa) {
  const cod = clean(codEmpresa);
  if (!cod) return null;
  if (empresaCache.has(cod)) return empresaCache.get(cod);
  const token = localStorage.getItem('authToken');
  if (!token) return null;
  const request = fetch(`${getApiBaseUrl()}/api/relatorios/empresa/${encodeURIComponent(cod)}`, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  })
    .then((res) => (res.ok ? res.json() : null))
    .then((json) => (json?.success ? json.data || null : null))
    .catch(() => null);
  empresaCache.set(cod, request);
  const data = await request;
  if (!data) empresaCache.delete(cod);
  return data;
}

/**
 * @param {object} row linha de Relatórios (`row.original`)
 * @param {{ assinaturaSvg?: string|null, assinaturaSignerName?: string|null, fotos?: { src: string, label?: string }[] }} go
 */
export async function buildRelatoriosOsReportOrder(row, go = {}) {
  const r = row || {};
  const empresa = await fetchEmpresaHeader(r.codEmpresa);
  const cidadeUf = [clean(r.cidade), clean(r.uf)].filter(Boolean).join(' - ');
  const endereco = [clean(r.logradouro), clean(r.bairro), cidadeUf, clean(r.cep)].filter(Boolean).join(', ');

  return {
    id: clean(r.os),
    tipo: TIPO_CODE[clean(r.tipo).toUpperCase()] || 'N',
    TB01007_NOME: clean(empresa?.nome) || clean(r.empresa),
    TB01007_CNPJ: clean(empresa?.cnpj),
    TB01007_ENDERECO: clean(empresa?.endereco),
    TB01008_NOME: clean(r.cliente),
    cliente: clean(r.cliente),
    solicitante: clean(r.solicitante),
    endereco,
    TB02115_LOCAL: clean(r.localizacao),
    equipamento: clean(r.equipamento),
    numeroSerie: clean(r.serie),
    patrimonio: clean(r.patrimonio),
    defeitoNome: clean(r.defeito) || clean(r.motivo),
    defeitoObservacao: clean(r.obsDefeito),
    dataAbertura: [clean(r.abertura), clean(r.aberturaHora)].filter(Boolean).join(' '),
    reportClosure: {
      condicao: clean(r.condicaoFinal),
      laudo: clean(r.laudo),
      dataIni: clean(r.inicioAtendimento),
      horaIni: clean(r.horaInicio),
      dataFim: clean(r.fimAtendimento),
      horaFim: clean(r.horaFim),
      tecnico: clean(r.tecnico),
      solicitanteNome: clean(go.assinaturaSignerName),
      assinaturaSrc: signatureSrc(go.assinaturaSvg),
      fotos: Array.isArray(go.fotos) ? go.fotos : [],
    },
  };
}
